import React, { Component } from "react";
import CommentSection from "./CommentSection";
import CommonUtil from "../../../utils/CommonUtil";

class CommentSectionContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: undefined
    };
    this.onCommentSubmit = props.onCommentSubmit;
  }

  onChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  validateForm = () => {
    const comment = this.state.comment;
    return comment !== undefined && CommonUtil.isEveryStringNotEmpty([comment]);
  };

  constructCommentData(comment, action) {
    const commentData = {
      note: comment,
      messageLogType: { id: action.id }
    };

    return commentData;
  }

  handleOnClick = action => {
    const comment = this.constructCommentData(this.state.comment, action);

    this.onCommentSubmit(comment);
    this.setState({ comment: undefined });
  };

  render() {
    return (
      <CommentSection
        comment={this.state.comment}
        onCommentChange={this.onChange}
        isValid={this.validateForm}
        comments={this.props.comments}
        selectedMessageLogType={this.props.selectedMessageLogType}
        messageLogTypes={this.props.messageLogTypes}
        handleOnClick={this.handleOnClick}
        onMessageLogTypeChange={this.props.onMessageLogTypeChange}
      />
    );
  }
}

export default CommentSectionContainer;
